module.exports = __webpack_public_path__ + "img/108.a9021d17.jpg";